import { setChecklists, setChecklist, setLoading, setError } from "../slices/checklist";
import axios from "axios";

export const duplicateChecklist = (id) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post(`/api/checklists/${id}/duplicate`, {}, config);
    dispatch(setError(null));
    return data;
  } catch (error) {
    const errorMsg =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        ? error.message
        : "An unexpected error occurred duplicating checklist. Please try again later";
    dispatch(setError(errorMsg));
    throw error;
  }
};

export const getChecklists = () => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.get("/api/checklists");
    dispatch(setChecklists(data.checklists));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading checklists. Please try again later"
      )
    );
  }
};

export const getChecklist = (id) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.get(`/api/checklists/${id}`);
    dispatch(setChecklist(data.checklist));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading checklist. Please try again later"
      )
    );
  }
};

export const insertChecklist = (checklistData) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post("/api/checklists", checklistData, config);
    console.log("Inserted checklist data:", data);
    return data;
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred creating checklist. Please try again later"
      )
    );
  }
};

export const editChecklist = (id, checklistData) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.put(`/api/checklists/${id}`, checklistData, config);
    dispatch(setError(null));
    return data;
  } catch (error) {
    const errorMsg =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        ? error.message
        : "An unexpected error occurred updating checklist. Please try again later";
    dispatch(setError(errorMsg));
    throw error;
  }
};

export const deleteChecklist = (id) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.delete(`/api/checklists/${id}`, config);
    dispatch(setError(null));
    return data;
  } catch (error) {
    const errorMsg =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message
        ? error.message
        : "An unexpected error occurred deleting checklist. Please try again later";
    dispatch(setError(errorMsg));
    throw error;
  }
};
